import { PortfolioProfile } from "../../../../../../shared/types/PortfolioProfile";
import { PortfolioSettingsModel } from "../../../../../portfolio-info/types/PortfolioSettingsModel";

class ChartDataSourceService {
    getDataSource = (
        portfolioProfile: PortfolioProfile,
        portfolioSettings: PortfolioSettingsModel,
        comparedPortfolioProfile: PortfolioProfile
    ): number[][] => {
        const dataSource: number[][] = [];

        dataSource.push(portfolioProfile.data.map(x => x.price));

        dataSource.push(portfolioProfile.data.map(x => x.currentDateBalance));
        
        dataSource.push(portfolioProfile.data.map(x => x.customDateBalance1));
        dataSource.push(portfolioProfile.data.map(x => x.customDateBalance2));
        dataSource.push(portfolioProfile.data.map(x => x.customDateBalance3));
     
        dataSource.push(portfolioProfile.data.map(x => x.expirationDateBalance));

        if (portfolioSettings.useComparedPortfolio) {
            dataSource.push(comparedPortfolioProfile.data.map(x => x.currentDateBalance));
            dataSource.push(comparedPortfolioProfile.data.map(x => x.customDateBalance1));
            dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationDateBalance));
        }

        return dataSource;
    }
}

export const chartDataSourceService = new ChartDataSourceService();